import { httpsCallable } from 'firebase/functions';
import type {
  CreatePrestigeConfigurationResponse,
  CreateSignaturePergolaOrderResponse,
  FunctionsService,
} from '@core';
import { firebaseFunctions } from './firebase';

const createPrestigeConfigurationCallable = httpsCallable<
  { style?: string; color?: string },
  CreatePrestigeConfigurationResponse
>(firebaseFunctions, 'createPrestigeConfiguration');

const createSignaturePergolaOrderCallable = httpsCallable<
  { buildNumber: string; previewImage?: string },
  CreateSignaturePergolaOrderResponse
>(firebaseFunctions, 'createSignaturePergolaOrder');

export const functionsService: FunctionsService = {
  async createPrestigeConfiguration(params) {
    const response = await createPrestigeConfigurationCallable({
      style: params?.style,
      color: params?.color,
    });
    return response.data;
  },

  async createSignaturePergolaOrder(buildNumber, previewImage) {
    const response = await createSignaturePergolaOrderCallable({
      buildNumber,
      previewImage,
    });
    return response.data;
  },
};
